'use client';
/**
 * @file     useAppTheme.ts
 * @readme   ./README.md
 * @purpose  Hook that returns ThemeContextValue from ThemeContext, throwing if used outside AppThemeProvider.
 */
import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';

export const useAppTheme = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useAppTheme must be used inside AppThemeProvider');
  }

  return context;
};
